export default "__VITE_ASSET__DaT_cPr1__"